const SD_SERVICES = {
  PATHS: {
    PROFILE: '/profile',
    STUDYCHOICE: '/studychoice',
  },
}

export default SD_SERVICES
